import { setupUnauthorizedInterceptor } from "@/services/interceptors";
import { setupAuthInterceptor } from "@/services/interceptors/auth";
import { setupErrorInterceptor } from "@/services/interceptors/error";
import axios from "axios";

const PROD_API = "https://api.verden.agr.br/api";

/**
 * Deriva a base da API do host em que o app está sendo servido, trocando o label
 * `app` por `api`: `app.verden.agr.br` → `api.verden.agr.br`,
 * `app.stage.verden.agr.br` → `api.stage.verden.agr.br`. Assim a mesma imagem
 * serve todos os ambientes.
 *
 * Só o label `app` deriva. Qualquer outro host cai na API de produção, que é o
 * comportamento anterior a esta função. Trocar o primeiro label seja ele qual
 * for parece mais geral e é pior: `www.app.verden.agr.br` viraria o domínio
 * inexistente `api.app.verden.agr.br`, um IP viraria `api.176.49.58`, e
 * `hml.stage.verden.agr.br` apontaria um ambiente para a API de outro.
 *
 * O admin-frontend não passa por aqui — ele resolve a URL por build arg.
 */
export function resolveApiBaseUrl(hostname: string): string {
  if (hostname === "localhost") return "http://api.localhost/api";
  const environment = hostname.match(/^app\.((?:[^.]+\.)*verden\.agr\.br)$/);
  return environment ? `https://api.${environment[1]}/api` : PROD_API;
}

export const api = axios.create({
  baseURL: resolveApiBaseUrl(window.location.hostname),
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

// Configurar interceptors
setupAuthInterceptor(api);
setupErrorInterceptor(api);
setupUnauthorizedInterceptor(api);

export default api;
